'use client'

import { memo, useMemo } from 'react'

import { useParams, useRouter } from 'next/navigation'

import { useTranslation } from 'react-i18next'

import { useGetInitialCategoriesQuery } from '@/redux/services/catalogApi'

export const Breadcrumbs = memo(function Breadcrumbs() {
    const navigate = useRouter()
    const { t } = useTranslation()

    const { data: categories } = useGetInitialCategoriesQuery()

    const params = useParams()

    const catalogBreadCrumbs = useMemo(() => {
        const paramsCategory = params?.catalog?.[0]

        if (!paramsCategory) return [t('catalog')]

        const category = categories?.find(c => c.translit === paramsCategory)

        if (!category) return [t('catalog')]

        return [t('catalog'), t(category.title)]
    }, [categories, params?.catalog])

    const handleCatalogClick = () => {
        const animalType = params?.catalog?.[1]

        if (animalType) {
            navigate.push(`/catalog/${animalType}`)
        } else if (categories?.find(c => c.translit === params?.catalog?.[0])) navigate.push(`/catalog`)
    }

    return (
        <nav className='catalog__title-wrapper'>
            {catalogBreadCrumbs?.map((title, i) => (
                <div
                    key={i}
                    style={{ display: 'flex', alignItems: 'center', columnGap: '30px' }}
                    onClick={() => i === 0 && handleCatalogClick()}
                >
                    <h1
                        className={`catalog__title ${
                            i === catalogBreadCrumbs.length - 1 &&
                            catalogBreadCrumbs.length > 1 &&
                            'catalog__title_current'
                        }`}
                    >
                        {title}
                    </h1>
                    {i !== catalogBreadCrumbs.length - 1 && (
                        <svg
                            width='24'
                            height='24'
                            viewBox='0 0 24 24'
                            fill='none'
                            xmlns='http://www.w3.org/2000/svg'
                        >
                            <path
                                d='M10 19L15.9442 12.0651C15.9763 12.0276 15.9763 11.9724 15.9442 11.9349L10 5'
                                stroke='#A9B4D1'
                                strokeWidth='2'
                                strokeLinecap='round'
                            />
                        </svg>
                    )}
                </div>
            ))}
        </nav>
    )
})
